// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__uDdeP","title":"AfterFrontImage_title__3Nsop"};